import { Dispatch, SetStateAction, useState } from 'react';

interface Props {
  initPageSize?: number;
  initPage?: number;
}

export interface Pagination {
  page: number;
  pageSize: number;
  totalCount: number;
  setPage: Dispatch<SetStateAction<number>>;
  setPageSize: Dispatch<SetStateAction<number>>;
  setTotalCount: Dispatch<SetStateAction<number>>;
}

export function usePagination({ initPageSize = 2000, initPage = 0 }: Props = {}): Pagination {
  const [pageSize, setPageSize] = useState(initPageSize);
  const [page, setPage] = useState(initPage);
  const [totalCount, setTotalCount] = useState(0);

  return {
    pageSize,
    page,
    totalCount,
    setPageSize,
    setPage,
    setTotalCount,
  };
}
